<ng-container *ngIf="!isDisabled">
  <button
    nz-button
    nzType="link"
    nzSize="small"
    class="btn-secondary-header button-link labs-button"
    [ngClass]="{
      'btn-secondary-header-active': watchlistlabsMenuVisible,
      'compspage-btn': this.pageName === 'comps'
    }"
    nz-dropdown
    [(nzVisible)]="watchlistlabsMenuVisible"
    nzTrigger="click"
    [nzDropdownMenu]="menu"
    [nzPlacement]="position"
    [nzClickHide]="false"
    [nzBackdrop]="false"
  >
    <div class="display-flex flex-align-center" style="font-size: 13px">
      <va-icon size="medium" name="flask" class="flask-icon"></va-icon>
      Labs Pages
      <va-icon
        *ngIf="!watchlistlabsMenuVisible"
        size="small"
        name="caret-down"
        class="caret-icon"
      ></va-icon>
      <va-icon
        *ngIf="watchlistlabsMenuVisible"
        [isFontAwesome]="true"
        [name]="faCaretUp"
        class="caret-icon"
      ></va-icon>
    </div>
  </button>
</ng-container>
<ng-container *ngIf="isDisabled">
  <button
    nz-button
    nzType="link"
    [disabled]="isDisabled"
    class="btn-disabled button-link labs-button"
    [ngClass]="{
      'compspage-btn': this.pageName === 'comps'
    }"
  >
    <div class="display-flex flex-align-center" style="font-size: 13px">
      <va-icon size="medium" name="flask" class="flask-icon"></va-icon>
      Labs Pages
      <va-icon
        size="small"
        *ngIf="!watchlistlabsMenuVisible"
        name="caret-down"
        style="margin-left: 3px"
      ></va-icon>
    </div>
  </button>
</ng-container>

<nz-dropdown-menu class="lab-menu-pannle" #menu="nzDropdownMenu">
  <div class="labnav-container">
    <div class="nav-group" *ngFor="let item of labsPages | keyvalue">
      <div class="group-heading">
        {{ item.key }}
      </div>
      <div
        class="group-link"
        *ngFor="let data of item.value"
        (click)="pageSelected(data)"
      >
        <va-icon
          *ngIf="data.reportcycle_name === 'Prod'"
          name="check-circle"
        ></va-icon>
        <va-icon
          *ngIf="data.reportcycle_name === 'EA'"
          [isFontAwesome]="true"
          [name]="faHourglassStart"
        ></va-icon>
        <va-icon
          *ngIf="data.reportcycle_name === 'Labs & EA'"
          name="exclamation-triangle"
        ></va-icon>
        &nbsp;{{ data.name }}
      </div>
    </div>
  </div>
</nz-dropdown-menu>
